<script setup lang="ts">
import type { Network } from '@/features/social-networks/type';
import { MixpanelInstance } from '@/plugins/mixpanel/mixpanel';

type Props = {
  network: Network;
  disabled?: boolean;
};

const props = defineProps<Props>();

function openInNewTab(network: Network) {
  /** REPORT **/
  MixpanelInstance.track('share_profile', {
    share_method: `share_linkedin`,
  });

  if (network.link) window.open(network.link, '_blank')?.focus();
}
</script>

<template>
  <v-btn
    class="px-4 py-2"
    size="auto"
    variant="outlined"
    icon
    @click="openInNewTab(props.network)"
    :disabled="props.disabled"
  >
    <v-icon icon="fab fa-linkedin-in" :size="20" />
    <span class="ms-2 text-af-grey-700">{{ $t('general.share') }}</span>
  </v-btn>
</template>

<style scoped></style>
